module.exports = __webpack_public_path__ + "static/media/how_ml.76fdd36d.vtt";